<div class="hdmui hdmui-m-0 wrapper hdmui-container inactivity-timer-dialog" data-testid="inactivity-timer-dialog">
    <section class="hdmui-content inactivity-timer-dialog__content">
        @let entries = (data.entries$ | async) ?? [];

        @if (entries.length > 0) {
            <data-terminal-inactivity-timer
                [timer$]="entries[0].timer$"
                [machineId]="entries[0].machineId"
                (primaryButtonClick)="onCloseAll()"
                (secondaryButtonClick)="onNavigate(entries[0].machineId)"
            />

            @if (entries.length > 1) {
                <p
                    class="hdmui-caption inactivity-timer-dialog__list-info"
                    data-testid="inactivity-timer-remaining-count"
                >
                    {{
                        'DC.INACTIVITY_PAGE.REMAINING_INACTIVE_MACHINES_INFO' | translate: { count: entries.length - 1 }
                    }}
                </p>

                <ul class="inactivity-timer-dialog__list" data-testid="inactivity-timer-dialog-list">
                    @for (entry of entries.slice(1); track entry.machineId) {
                        <li class="inactivity-timer-dialog__list-item">
                            <span class="inactivity-timer-dialog__list-machine">{{ entry.machineId }}</span>
                            <span class="inactivity-timer-dialog__list-counter">
                                {{ (entry.timer$ | async) || 0 | timeFormatter }}
                            </span>
                            <button
                                class="inactivity-timer-dialog__list-button"
                                mat-button
                                (click)="onNavigate(entry.machineId)"
                                data-testid="inactivity-timer-compact-navigate"
                            >
                                {{ 'DC.INACTIVITY_PAGE.SECONDARY_BUTTON' | translate }}
                            </button>
                        </li>
                    }
                </ul>
            }
        }
    </section>
</div>
